// removed by extract-text-webpack-plugin
module.exports = {"root":"accounts_root_dwv9ti","account":"accounts_account_8w1jas","powered":"accounts_powered_6ljlek"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/accounts/accounts.scss
// module id = 554
// module chunks = 0